import React, { useContext, useState } from 'react';
import FormModalFormatter, { IFormModalFormatterProps } from '../../../components/modals/formatters/FormModalFormatter';
import ConnectedFormContext from '../../../components/Context/ConnectedFormContext';
import { useLazyQuery } from '@apollo/client';
import { ISalesOrderTemporaryQueryVariables, ISalesOrderTemporaryQueryResult } from '../../../graphql/schema/p4types';
import SalesOrderTemporaryQuery from 'graphql/queries/sales/SalesOrderTemporaryQuery.graphql';
import DateFormatter from '../../../components/grid-addons/formatters/DateFormatter';

const LazyScheduleForm = React.lazy(() => import('../../../views/sales/salesOrderForm/ScheduleForm'));

const ScheduleFormModalFormatter = ({ value, dependentValues }: IFormModalFormatterProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const connectedForm = useContext(ConnectedFormContext);
  const [temporarySalesOrderQuery] = useLazyQuery<ISalesOrderTemporaryQueryResult, ISalesOrderTemporaryQueryVariables>(
    SalesOrderTemporaryQuery,
    {
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        connectedForm.change(false, data.data);
      },
    }
  );

  const orderLine = dependentValues.rowData;

  // don't render anything if the line is already a scheduled line
  if (orderLine?.scheduled ?? true) {
    return <DateFormatter dependentValues value={orderLine?.targetDate} />;
  }

  return (
    <FormModalFormatter
      zIndex={dependentValues?.options?.modalProps?.zIndex}
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      value={'SCHEDULE'}
    >
      <LazyScheduleForm
        orderLine={orderLine}
        salesOrder={connectedForm?.values}
        onClose={() => {
          temporarySalesOrderQuery({
            variables: {
              uuid: connectedForm?.values?.uuid,
              tradeCounter: false,
            },
          }).then();
          setModalOpen(false);
        }}
      />
    </FormModalFormatter>
  );
};

export default ScheduleFormModalFormatter;
